var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{class:_vm.classComponent,attrs:{"cols":"12"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }